export default {
  zh: {
    uiDemo: 'UI 示例',
    companyInfo: '公司信息',
    users: '用户',
    orgChart: '公司结构',
    permissions: '权限',
    leads: '潜在客户',
    accounts: '客户',
    opportunities: '机会',
    fields: '字段',
    pageLayout: '自定义页面结构',
    email: '电子邮件设置',
    workflow: '业务流程设置',
    templates: '邮件模版',
    Campaign: '营销邮件',
    systems: '系统设置',
    ipWhiteLists: 'IP 白名单',
    searchLayout: '自定义搜索页面结构',
    settings: '设置',
    generalSettings: '常规设置',
    import: '导入',
    export: '导出',
    workflows: '工作流',
    apiToken: 'API 令牌'
  },
  en: {
    uiDemo: 'UI Demo',
    companyInfo: 'Company Info',
    users: 'Users',
    orgChart: 'Organization Chart',
    permissions: 'Permissions',
    leads: 'Leads',
    accounts: 'Accounts',
    opportunities: 'Opportunities',
    fields: 'Fields',
    pageLayout: 'Page Layout',
    email: 'Email Communications',
    workflow: 'Workflow Automation',
    templates: 'Email Template',
    Campaign: 'Email Campaign',
    systems: 'Systems',
    ipWhiteLists: 'IP White Lists',
    searchLayout: 'Search Layout',
    settings: 'Settings',
    generalSettings: 'General Settings',
    import: 'Import',
    export: 'Export',
    workflows: 'Workflow',
    apiToken: 'API Token'
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/sider.js